import type { RenderComponentProps } from "replo-runtime/shared/types";

import React from "react";

import { getAvailableOptionValues } from "../../../utils/option";
import { useProductTileContext } from "./ProductTileContext";

export const BundleProductVariantSelector: React.FC<RenderComponentProps> = ({
  component,
  componentAttributes,
}) => {
  const optionKey = component.props.optionKey as
    | "option1"
    | "option2"
    | "option3";
  const {
    selectOptionValue,
    selectedVariant,
    productData: contextProductData,
    selectedOptions,
  } = useProductTileContext();

  // Get option values with availability using utility function
  const optionValues = React.useMemo(() => {
    if (!contextProductData) {
      return [];
    }
    return getAvailableOptionValues(
      contextProductData,
      selectedOptions,
      optionKey,
    );
  }, [contextProductData, selectedOptions, optionKey]);

  if (!contextProductData) {
    return null;
  }

  const handleChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    selectOptionValue(optionKey, e.target.value);
  };

  return (
    <select
      {...componentAttributes}
      onChange={handleChange}
      value={selectedVariant?.[optionKey] ?? ""}
    >
      {optionValues.map(({ available, title }) => {
        return (
          <option key={title} value={title} disabled={!available}>
            {title}
          </option>
        );
      })}
    </select>
  );
};
